import { PartnerSalesTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "../UiActions";

// ----------------------------------------------------------------------

export const PartnerSalesActions = {};

// THUNKS
// ----------------------------------------------------------------------

PartnerSalesActions.fetch = (month, year) => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    let requestData = {
      month, 
      year
    };

    dispatch(PartnerSalesActions.start());

    let queueId = "PartnerSales-" + Date.now();
    dispatch(UiActions.queue(queueId));

    ExecuteRequest(
      GlamboxEndpoints.Partner.getPartnerSales,
      requestData,
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(PartnerSalesActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {
          dispatch(PartnerSalesActions.success(true));
          
          dispatch(PartnerSalesActions.set(result));
        } else {
          // TODO: Descoomentar!
          // dispatch(PartnerSalesActions.error(error));
        }
      }
    );
  };
};

PartnerSalesActions.start = () => {
  return (dispatch) => {
    dispatch(PartnerSalesActions.pending(true));
    dispatch(PartnerSalesActions.success(false));
    dispatch(PartnerSalesActions.error(null));
  };
};

// ACTIONS PURAS
// ----------------------------------------------------------------------

PartnerSalesActions.sync = () => ({
  partnerSales: {
    lastSync: Date.now()
  },
  type: PartnerSalesTypes.sync
});

PartnerSalesActions.set = (partnerSales) => ({
  partnerSales: {
    data: partnerSales,
    lastSync: Date.now()
  },
  type: PartnerSalesTypes.set
});

PartnerSalesActions.unset = () => ({
  partnerSales: InitialState.createSyncObject(),
  type: PartnerSalesTypes.unset
});

PartnerSalesActions.success = (success) => ({
  partnerSales: {
    success: (success === true)
  },
  type: PartnerSalesTypes.success
});

PartnerSalesActions.pending = (pending) => ({
  partnerSales: {
    pending: (pending === true)
  },
  type: PartnerSalesTypes.pending
});

PartnerSalesActions.error = (error) => ({
  partnerSales: {
    error
  },
  type: PartnerSalesTypes.error
});
